import makeRequest from './make-request'
import CustomCalendar from './air-datepicker'
import {getMontNameByNumber} from './air-datepicker'

let todayDate = new Date()
let todayMonth = todayDate.getMonth()
let todayMonthDay = todayDate.getDate()

let datepickerContainer = document.querySelector('#datepicker')
let currentDate = new Date()
let currentMonth = currentDate.getMonth()
let currentMonthDay = currentDate.getDate()
let currentYear = currentDate.getFullYear()
let currentMonthData, calendarBack, monthContainer, calendar, currentMonthContainer

initCalendar()
async function initCalendar(){
    if (!datepickerContainer)
        return false

    // calendarBack = document.querySelector('.calendar-back')
    monthContainer = document.querySelector('#month-container')
    // calendarBack.addEventListener('click', onDayDeselect)

    let nextMonth = currentMonth+1
    nextMonth = nextMonth > 11 ? 0 : nextMonth
    let nextMonthResult = getMonth({
        date: {
            monthNum: nextMonth,
            year: nextMonth == 1 ? currentYear+1 : currentYear,
            todayMonthDay,
            todayMonth
        }
    })
    nextMonthResult.then((result) => {
        let addToNextMonth = true
        if (result.status == 'not-found') addToNextMonth = false
        createCalendar(addToNextMonth)
    })

    const createCalendar = (addToNextMonth = true) =>{
        calendar = new CustomCalendar({
            onDateSelect: onDatePick,
            containerSelector: '#datepicker',
            onToggleMonth: onDayDeselect,
            afterInit,
            addToNextMonth
        })
    }


    let result = await getMonth({
        date: {
            monthNum: currentMonth,
            year: currentYear,
            todayMonthDay,
            todayMonth
        }
    })
    processResult(result)

}
function afterInit(){
    currentMonthContainer = datepickerContainer.querySelector('.section-church-calendar__calendar-current-month')
    currentMonthContainer.addEventListener('click', onDayDeselect)
}
function onDatePick(argsObject){
    if (!argsObject.date){
        onDayDeselect()
    }
    else{
        onDaySelect(argsObject.date)
    }
}
async function onDaySelect(date){
    let pickedDate = new Date(date)
    let pickedMonth = pickedDate.getMonth()
    let pickedYear = pickedDate.getFullYear()
    let pickedMonthDay = pickedDate.getDate()


    if (pickedMonth != currentMonth || pickedYear != currentYear){
        currentDate = pickedDate
        currentYear = pickedYear
        currentMonth = pickedMonth
        currentMonthDay= pickedMonthDay

        let result = await getMonth({
            date: {
                monthNum: currentMonth,
                year: currentYear,
                monthDay: currentMonthDay,
                todayMonthDay,
                todayMonth
            }
        })
        processResult(result,currentMonthDay)
    }
    else{
        let html = ''
        let filteredDay = currentMonthData.find((dayElem) => dayElem.day == pickedMonthDay)

        if (filteredDay){
            fillMonthBlocks([filteredDay])
        }
        else
            insertMonthContent(NotFound())

    }
    // calendarBack.classList.remove('hidden')
    currentMonthContainer.classList.add('active')
}
function onDayDeselect(){
    // calendarBack.classList.add('hidden')
    currentMonthContainer.classList.remove('active')
    fillMonthBlocks(currentMonthData)
    calendar.unselectDate()
}
function processResult(result,pickedMonthDay=false){
    switch (result.status){
        case 'success':
            currentMonthData = result.days
            if (pickedMonthDay){
                let filteredDay = currentMonthData.find((dayElem) => dayElem.day == pickedMonthDay)
                if (filteredDay){
                    fillMonthBlocks([filteredDay])
                }
                else
                    insertMonthContent(NotFound())
            }
            else{
                fillMonthBlocks(currentMonthData)
            }
            break;
        case 'content-empty':
            let str = NotFound('Расписание на месяц не заполнено')
            insertMonthContent(str)
            currentMonthData = []
            break;
        case 'not-found':
            str = NotFound()
            insertMonthContent(str)
            currentMonthData = []
            break;
    }
}
function fillMonthBlocks(daysArray){
    let prevDay = 0
    let html = ''

    daysArray.forEach(dayElem => {
        dayElem.sluzhba.forEach(elem => {
            let data = {
                day: dayElem.day,
                monthNum: currentMonth,
                sluzhbaTime: elem['time'],
                sluzhbaText: elem['text'],
            }

            if (dayElem.day != prevDay)
                data.saints = dayElem.saints

            prevDay = dayElem.day
            let tpl = createDayTemplate(data)
            html += tpl
        })
    });
    insertMonthContent(html)
}
async function getMonth({date,noPastDates=1}){
    let data = new FormData()
	data.append('action','calendar')
    data.append('year', date.year)
    data.append('month_num', date.monthNum)
    data.append('today_month_day', date.todayMonthDay)
    data.append('today_month_num', date.todayMonth)
    data.append('no_past_dates', noPastDates)

    let result = await makeRequest(window.ajaxUrl, data, "POST")
    return result
}
function createDayTemplate({day, monthNum, sluzhbaTime, sluzhbaText, saints=''}){
    let month = getMontNameByNumber(monthNum,1)
    let tpl = `
        <div class="section-church-calendar__list-block">
            <p class="section-church-calendar__list-date">${day} ${month} <span>/</span> ${sluzhbaTime}</p>
            <h3 class="section-church-calendar__list-title">${sluzhbaText}</h3>
    `
    if (saints)
        tpl+= `<p class="section-church-calendar__list-saints">${saints}</p>`

    tpl += '</div>'

    return tpl
}
function insertMonthContent(htmlStr){
    monthContainer.innerHTML = htmlStr
}
function NotFound(msg='На эту дату еще не запланировано служений'){
    return `<p>${msg}</p>`
}